import { render } from "./PageResetPassword.vue?vue&type=template&id=18c264ed&scoped=true"
import script from "./PageResetPassword.vue?vue&type=script&lang=js"
export * from "./PageResetPassword.vue?vue&type=script&lang=js"

import "./PageResetPassword.vue?vue&type=style&index=0&id=18c264ed&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18c264ed"]])

export default __exports__